export const PII_MAPPING = {
  dob: ['birth_date'],
  name: ['name_last', 'name_first'],
  business_name: ['business_name'],
  business_alternate_name: ['business_alternate_name'],
  phone: ['phone_number'],
  ssn: ['document_ssn'],
  email: ['email_address'],
  document_national_id: ['document_national_id'],
  ip_address: ['ip_address_v4', 'ip_address_v6'],
  address: [
    'address_line_1',
    'address_line_2',
    'address_city',
    'address_state',
    'address_postal_code',
    'addresses',
  ],
  business_registry_id: ['business_registry_id'],
  business_id: ['business_federal_ein'],
};

export const DUPLICATE_PII_MAPPING = {
  ssn: 'documentSsn',
  email: 'emailAddress',
  phone: 'phoneNumber',
  document_national_id: 'documentNationalId',
  ip_address_v4: 'ipAddressV4',
  ip_address_v6: 'ipAddressV6',
};

export const DISPLAY_NAME_MAPPING = {
  business_registry_id: 'Registry ID',
  business_id: 'Business ID',
};
